<template>
  <div class="all-users-page test-class">
    <h1 class="page-header color-1-100">All companies</h1>
    <div class="admin-gm-breadcrumbs" tabindex="-1">
      <router-link class="dashboard" to="/" v-if="getUserRole !== 'gm'">Dashboard</router-link>
      <router-link class="companies active" :to="{name: 'companies'}" v-if="getUserRole === 'gm' || getUserRole !== 'ca'">Companies</router-link>
      <router-link class="all-users" :to="{name: getUserRole === 'gm' ? 'users' : 'ca-users'}">Users</router-link>
      <router-link class="to-do" :to="{name: 'tasks'}" v-if="getUserRole !== 'gm'">Tasks</router-link>
      <!--<router-link class="ask-expert" to="#" v-if="getUserRole !== 'gm'">Ask an Expert</router-link>-->
    </div>
    <div class="content-section">
      <div class="data-list-heading">
        <div class="data-list-statusbar">
          <div class="data-list-statusbar__contains data-list-statusbar__block">{{ this.companiesSum }} companies</div>
          <ul class="data-list-statuses data-list-statusbar__block">
            <li v-for="(row, index) in statusbar.data"
                class="data-list-statuses__item">{{row + ' '}}
              <template v-if="index === 'active'">
                active
              </template>
              <template v-else-if="index === 'notactive'">
                inactive
              </template>
              <template v-else>
                archived
              </template>
            </li>
          </ul>
        </div>
        <router-link :to="{name: 'add-company'}" class="data-list-add" tabindex="-1">Add new company</router-link>
      </div>
      <div class="data-list-selected-filters" v-if="getDeviceType('desktop') && selectedFilters.length">
        <div class="data-list-selected-filters-applied">
          <span>Filters applied:<br/>{{ this.editedCompanies.length }} results</span>
        </div>
        <div class="data-list-selected-filters-body">
          <button v-for="filter in selectedFilters"
                  type="button"
                  @click="removeSelectedFilters(filter)"
                  @mouseover="addHoverElement([filter])"
                  @mouseleave="removeHoverElements"
                  :class="{'hover-filter-element': isExist(filter)}">
            <span>{{ filter.label }}</span>
          </button>
          <span class="data-list-selected-filters-remove-all"
                @click="removeAllFilters"
                @mouseover="statusbar.filter.isHover = true"
                @mouseleave="statusbar.filter.isHover = false">Clear all filters</span>
        </div>
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead v-bind:filters="getTabletFiltersAppliedText()">
          <tr class="inside-table-filters" v-if="(getDeviceType('tablet') || getDeviceType('mobile')) &&  selectedFilters.length">
            <th colspan="9">
              <div class="data-list-selected-filters-body">
                <button v-for="filter in selectedFilters"
                        type="button"
                        @click="removeSelectedFilters(filter)"
                        @mouseover="addHoverElement([filter])"
                        @mouseleave="removeHoverElements"
                        :class="{'hover-filter-element': isExist(filter)}">
                  <span>{{ filter.label }}</span>
                </button>
                <span class="data-list-selected-filters-remove-all"
                      @click="removeAllFilters"
                      @mouseover="statusbar.filter.isHover = true"
                      @mouseleave="statusbar.filter.isHover = false">Clear all filters</span>
              </div>
            </th>
          </tr>
          <tr>
            <th class="data-list-search-col text-left column-search-head table-head-ceil" colspan="2"
                :class="{'active-ceil-head': filerTableHead.selectedCeil === 1,
                'hover-head-ceil': isExistSearchInOptions('name')}"
                @mouseover="addSearchHoverElement('name')"
                @mouseleave="removeSearchHoverElements">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                    title="ID and full name"
                    aria-label="ID and full name"
                    v-model="searchByName"
                    type="search"
                    class="table-search"
                    placeholder="ID and full name" />
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="column-role-head table-head-hover table-head-ceil"
                :class="{'active-ceil-head': filerTableHead.selectedCeil === 2,
                'hover-head-ceil': isExistInOptions(getCompaniesForSelect)}"
                @click.stop="showHideSubMenu(2)"
                @mouseover="addHoverElement(getCompaniesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 2}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Parent company</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-1"
                   v-show="filerTableHead.selectedCeil === 2"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getCompaniesForSelect"
                            :class="table-head-search"
                            v-model="companyParent" />
              </div>
            </th>
            <th class="column-status-head table-head-ceil"
                :class="{'hover-head-ceil': isExistInOptions(getStatusesForSelect)}"
                @click.stop="showHideSubMenu(3)"
                @mouseover="addHoverElement(getStatusesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 3}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Status</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-2"
                   v-show="filerTableHead.selectedCeil === 3"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getStatusesForSelect"
                            v-model="companyStatus" />
              </div>
            </th>
            <th class="column-status-head table-head-ceil"
                :class="{'hover-head-ceil': isExistInOptions(getIndustriesForSelect)}"
                @click.stop="showHideSubMenu(4)"
                @mouseover="addHoverElement(getIndustriesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 4}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Industry</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-3"
                   v-show="filerTableHead.selectedCeil === 4"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getIndustriesForSelect"
                            v-model="companyIndustry" />
              </div>
            </th>
            <th class="column-status-head table-head-ceil"
                :class="{'hover-head-ceil': isExistInOptions(getDefaultRegistrationRolesForSelect)}"
                @click.stop="showHideSubMenu(5)"
                @mouseover="addHoverElement(getDefaultRegistrationRolesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 5}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">User type</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-5"
                   v-show="filerTableHead.selectedCeil === 5"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search"
                            :options="getDefaultRegistrationRolesForSelect"
                            v-model="userType" />
              </div>
            </th>
            <th class="column-created-head table-head-ceil"
                @click.stop="changeOrderBy('users', true)">
              <div class="caption-head caption-head-order">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">No. of users</span>
                </div>
                <div class="caption-head-order-change">
                  <div class="caption-head-order-up"
                       :class="{'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'users' && this.companyOrderBy.order}"></div>
                  <div class="caption-head-order-down"
                       :class="{'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'users' && !this.companyOrderBy.order}"></div>
                </div>
              </div>
            </th>
            <th class="column-created-head table-head-ceil"
                @click.stop="changeOrderBy('created', true)">
              <div class="caption-head caption-head-order">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Start date</span>
                </div>
                <div class="caption-head-order-change">
                  <div class="caption-head-order-up"
                       :class="{'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'created' && this.companyOrderBy.order}"></div>
                  <div class="caption-head-order-down"
                       :class="{'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'created' && !this.companyOrderBy.order}"></div>
                </div>
              </div>
            </th>
            <th class="column-active-head table-head-ceil"
                @click.stop="changeOrderBy('expire', true)">
              <div class="caption-head caption-head-order">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Expires on</span>
                </div>
                <div class="caption-head-order-change">
                  <div class="caption-head-order-up"
                       :class="{'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'expire' && this.companyOrderBy.order}"></div>
                  <div class="caption-head-order-down"
                       :class="{'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'expire' && !this.companyOrderBy.order}"></div>
                </div>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(company, i) in editedCompanies" @click="goToCompanyEdit(company.id)" v-if="i < offset">
            <td class="id-cell text-center cellpadding" data-title="ID" v-if="company.type === 'show'">{{ company.id }}</td>
            <td class="name-cell cellpadding" data-title="ID and full name:" v-if="company.type === 'show'"><span v-if="getDeviceType('tablet') || getDeviceType('mobile')">{{ company.id }} </span>{{ company.name }}</td>
            <td class="email-cell cellpadding" data-title="Parent:" v-if="company.type === 'show'">{{ company.parent ? company.parent.name : 'n/a' }}</td>
            <td class="role-cell cellpadding" data-title="Status:" v-if="company.type === 'show'">{{ getCompanyStatus(company).label }}</td>
            <td class="title-cell cellpadding" data-title="Industry:" v-if="company.type === 'show'">{{ company.industry ? company.industry.name : 'n/a' }}</td>
            <td class="title-cell cellpadding" data-title="User type:" v-if="company.type === 'show'">{{ company.userType ? company.userType.name : 'n/a' }}</td>
            <td class="company-cell cellpadding" data-title="No. of users:" v-if="company.type === 'show'">{{ company.users }}</td>
            <td class="created-cell cellpadding text-center" data-title="Created on:" v-if="company.type === 'show'">{{ company.created ? convertDate(company.created, '.') : convertDate(company.start_date, '.') }}</td>
            <td class="last-login-cell cellpadding text-center" data-title="Last login:" v-if="company.type === 'show'">{{ company.subscription_end ? convertDate(company.subscription_end, '.') : 'n/a' }}</td>
          </tr>
          </tbody>
        </table>
        <div class="load-more-container" v-if="this.offset <= this.editedCompanies.length">
          <div class="load-more-btn" @click="loadMore()">
            <div id="wave"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>Load more
          </div>
        </div>
      </div>
    </div>
    <app-spiner v-if="false" />
  </div>
</template>

<script>
import api from '@/api'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/ban'
import { mapGetters, mapActions } from 'vuex'
import AppSelect from '@/components/admin/common/Select'

export default {
  name: 'company-list',
  data () {
    return {
      ppt: 15,
      offset: 15,
      companies: [],
      editedCompanies: [],
      selectedAction: null,
      search: '',
      table: '',
      head: '',
      searchByName: '',
      hoverSearchElements: [],
      companyParent: null,
      role: null,
      lastEdited: null,
      companyStatus: null,
      companyIndustry: null,
      userType: null,
      companyIndustryList: [],
      companyTitleList: [],
      parentCompanyList: [],
      companyStatusList: [],
      companyType: null,
      companyOrderBy: {
        type: '',
        order: false
      },
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      confirmation: {
        action: '',
        isShown: false,
        id: null,
        style: {
          top: '100px'
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      datepicker: {
        isShown: false,
        from: null,
        to: null
      },
      statusbar: {
        data: [],
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      windowWidth: window.innerWidth
    }
  },
  methods: {
    ...mapActions([
      // 'getRoles',
      // 'getCompanies',
      'setInformationMsg',
      'getDefaultRegistrationRoles'
    ]),
    fetchAllContentByScroll (page, limit) {
      this.$http.get(api.URLS.companyList + '?limit=' + limit + '&page=' + page, api.headersAuthSettings)
        .then((res) => {
          let companies = res.body.data.items
          let parents = []
          companies.sort((a, b) => a.name > b.name).forEach(function (company) {
            if (company.parent === null) {
              let children = companies.filter(item => item.parent !== null && item.parent.id === company.id)
              parents.push(company)
              children.forEach(function (child) {
                parents.push(child)
              })
            }
          })
          this.companies = parents
          this.statusbar.data = res.body.count ? res.body.count : []
          let query = this.$route.query
          if (query && query.status) {
            if (query.status === 'active') {
              this.companyStatus = {
                value: 2,
                label: 'Active'
              }
            } else if (query.status === 'notactive') {
              this.companyStatus = {
                value: 1,
                label: 'Inactive'
              }
            } else if (query.status === 'disabled') {
              this.companyStatus = {
                value: 0,
                label: 'Archived'
              }
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addHoverElement (elements) {
      this.hoverElements = elements
    },
    addSearchHoverElement (type) {
      this.hoverSearchElements = type
    },
    removeHoverElements () {
      this.hoverElements = []
    },
    removeSearchHoverElements () {
      this.hoverSearchElements = ''
    },
    isExist (element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true
      }
      let el = this.hoverElements.find(item => {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistInOptions (options) {
      let hoverElement = this.hoverElements.length ? this.hoverElements[0] : {}
      let el = options.find(item => {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistSearchInOptions (type) {
      let hoverElement = this.hoverSearchElements ? this.hoverSearchElements : ''
      if (hoverElement === type) {
        return true
      }
    },
    removeSelectedFilters (filter) {
      if (this.searchByName) {
        this.searchByName = ''
      }
      if (this.companyStatus && this.companyStatus.label === filter.label && this.companyStatus.value === filter.value) {
        this.companyStatus = null
      }
      if (this.companyParent && this.companyParent.label === filter.label && this.companyParent.value === filter.value) {
        this.companyParent = null
      }
      if (this.companyIndustry && this.companyIndustry.label === filter.label && this.companyIndustry.value === filter.value) {
        this.companyIndustry = null
      }
      if (this.userType && this.userType.label === filter.label && this.userType.value === filter.value) {
        this.userType = null
      }
    },
    removeAllFilters () {
      this.searchByName = ''
      this.companyStatus = null
      this.companyParent = null
      this.companyIndustry = null
      this.userType = null
    },
    showHideSubMenu (num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    },
    lastActiveTime (timestamp) {
      if (!timestamp) return ''
      let string = ''
      let dateFrom = new Date(timestamp)
      let now = new Date()
      if (isNaN(dateFrom.getTime())) {
        return 'n/a'
      }
      let difference = Math.floor((+now - +dateFrom) / (1000 * 60 * 60))
      if (difference < 1) {
        string += 'less than 1 hour ago'
      } else if (difference >= 1 && difference < 24) {
        string += difference + ' hours ago'
      } else {
        string += this.convertDate(timestamp, '.')
      }
      return string
    },
    convertDate (payload, delimetr) {
      if (!payload) return
      let date = new Date(payload)
      if (isNaN(date.getTime())) {
        return 'n/a'
      }
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear
    },
    changeOrderBy (type, order) {
      this.companyOrderBy = {
        type: type,
        order: this.companyOrderBy !== null ? !this.companyOrderBy.order : order
      }
    },
    goToCompanyEdit (id) {
      let props = this.$router.resolve({
        name: 'edit-company',
        params: {id: id}
      })
      location.href = props.href
    },
    loadMore () {
      this.offset = this.offset + this.ppt
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width >= 940) {
        deviceName = 'desktop'
      } else if (width >= 480) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    },
    getTabletFiltersAppliedText () {
      let filterAppliedText = 'Apply Filters'
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.companies.length + ' results'
      }
      return filterAppliedText
    },
    getCompanyStatus (company) {
      let today = new Date()
      let endDay = new Date(company.subscription_end)
      if (company.enabled) {
        if (endDay < today) {
          return {
            label: 'Inactive',
            value: 1
          }
        } else {
          return {
            label: 'Active',
            value: 2
          }
        }
      } else {
        return {
          label: 'Archived',
          value: 0
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getUserRole',
      'getDefaultRegistrationRolesForSelect'
    ]),
    getStatusesForSelect () {
      return this.companyStatusList
    },
    getCompaniesForSelect () {
      return this.parentCompanyList
    },
    getIndustriesForSelect () {
      return this.companyIndustryList
    },
    filteredCompanies () {
      let result = this.companies
      result = this.companies.filter((company) => (company.id + ' ' + company.name).toLowerCase().indexOf(this.searchByName.toLowerCase()) > -1)
           .filter((company) => this.companyParent === null || (company.parent && company.parent.id === this.companyParent.value))
           .filter((company) => this.companyIndustry === null || (company.industry && company.industry.id === this.companyIndustry.value))
           .filter((company) => this.userType === null || (company.userType && company.userType.id === this.userType.value))
           .filter((company) => this.companyStatus === null || (this.getCompanyStatus(company).value === this.companyStatus.value))
      if (this.companyOrderBy !== null && this.companyOrderBy.type !== '') {
        let ascDesc = this.companyOrderBy.order ? 1 : -1
        if (this.companyOrderBy.type === 'expire') {
          return result.sort(function (a, b) {
            let firstDate = a.subscription_end !== undefined ? new Date(a.subscription_end) : ''
            let secondDate = b.subscription_end !== undefined ? new Date(b.subscription_end) : ''
            return ascDesc * (firstDate - secondDate)
          })
        } else if (this.companyOrderBy.type === 'users') {
          return result.sort((a, b) => ascDesc * (a.users.length - b.users.length))
        } else {
          return result.sort(function (a, b) {
            let firstDate
            let secondDate
            if (a.created) {
              firstDate = (a.created !== undefined && a.created !== 'Invalid Date') ? new Date(a.created) : ''
            } else {
              firstDate = (a.start_date !== undefined && a.start_date !== 'Invalid Date') ? new Date(a.start_date) : ''
            }
            if (b.created) {
              secondDate = (b.created !== undefined && b.created !== 'Invalid Date') ? new Date(b.created) : ''
            } else {
              secondDate = (b.start_date !== undefined && b.start_date !== 'Invalid Date') ? new Date(b.start_date) : ''
            }
            return ascDesc * (firstDate - secondDate)
          })
        }
      } else {
        return result
      }
    },
    companiesSum () {
      let count = 0
      for (let counter in this.statusbar.data) {
        count = count + +this.statusbar.data[counter]
      }
      return count
    },
    selectedFilters () {
      let filters = []
      if (this.searchByName) {
        filters.push({
          id: null,
          type: 'name',
          label: this.searchByName
        })
      }
      if (this.companyParent) {
        filters.push(this.companyParent)
      }
      if (this.companyIndustry) {
        filters.push(this.companyIndustry)
      }
      if (this.userType) {
        filters.push(this.userType)
      }
      if (this.companyStatus) {
        filters.push(this.companyStatus)
      }
      return filters
    }
  },
  watch: {
    filteredCompanies () {
      let editedCompanies = []
      this.offset = this.ppt
      this.companyTitleList = []
      this.parentCompanyList = []
      this.companyIndustryList = []
      this.companyStatusList = []
      this.filteredCompanies.forEach((company) => {
        company.type = 'show'
        if (company.parent) {
          let index = this.parentCompanyList.findIndex(x => x.label === company.parent.name)
          if (index === -1) {
            this.parentCompanyList.push({
              id: company.parent.id,
              label: company.parent.name,
              value: company.parent.id
            })
          }
        }
        if (company.industry) {
          let index = this.companyIndustryList.findIndex(x => x.label === company.industry.name)
          if (index === -1) {
            this.companyIndustryList.push({
              id: company.industry.id,
              label: company.industry.name,
              value: company.industry.id
            })
          }
        }
        let status = this.getCompanyStatus(company)
        let index = this.companyStatusList.findIndex(x => x.value === status.value)
        if (index === -1) {
          this.companyStatusList.push({
            label: status.label,
            value: status.value
          })
        }
        editedCompanies.push(company)
      })
      this.editedCompanies = editedCompanies
    },
    'confirmation.isShown' (value) {
      if (value) {
        this.confirmation.style.top = window.pageYOffset - 100 + 'px'
      }
    }
  },
  components: {
    AppSelect
  },
  created () {
    document.title = 'All Companies | Clear Assured'
    if (window.ga) {
      window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      window.ga('send', 'pageview', {
        'page': location.pathname,
        'location': location.href,
        'title': document.title
      })
    }
  },
  mounted () {
    this.fetchAllContentByScroll(1, 2000)
    this.getDefaultRegistrationRoles()
    // this.getCompanies()
    // this.getRoles()
    document.addEventListener('click', this.hideSubMenuTableHead)
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  }
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' ></style>



// WEBPACK FOOTER //
// CompanyList.vue?1416a7ec